
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/nursery-reluctance",
      function () {
        return require("private-next-pages/blog/nursery-reluctance.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/nursery-reluctance"])
      });
    }
  